let _ = t => t,
  _t;
import baseStyled from 'styled-components';
const styledWithTrellis = baseStyled;
const LoadingSkeleton = styledWithTrellis.span(_t || (_t = _`
  background: #eaf0f6;
  border-radius: 0.25rem;
  display: inline-flex;
  line-height: 1;
  overflow: hidden;
  position: relative;
  user-select: none;
  width: 100%;
  z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */
  height: ${0};
  @keyframes loading-skeleton {
    100% {
      transform: translateX(5%);
    }
  }

  &::after {
    animation: loading-skeleton 3s ease-out infinite;
    background-image: linear-gradient(-45deg, #fff0 35%, #fff8 50%, #fff0 65%);
    background-repeat: no-repeat;
    content: ' ';
    display: var(--animation-display-for-motion);
    position: absolute;
    transform: translateX(-100%);

    top: 0;
    left: 0;
    right: 0;
    height: 200%;
    width: 400%;
  }

  @media (prefers-reduced-motion) {
    --animation-display-for-motion: none; /* Disable animation */
  }
`), ({
  height
}) => `${height}px`);
export default LoadingSkeleton;